export default __webpack_public_path__ + "static/media/template_pro__0023_4---ruiCao.66314d7d.png";